const state = () => ({
  states: {},
});

const getters = {
  all: state => Object.keys(state.states).map(id => state.states[id]),
  get: state => state.states,
};

const mutations = {
  delete(state, assetAssociationIds) {
    assetAssociationIds.forEach(assetAssociationId => {
      delete state.states[assetAssociationId];
    });
  },
  set(state, states) {
    states.forEach(assetAssociationState => {
      state.states[assetAssociationState.assetAssociationId] = assetAssociationState;
    });
  },
};

const actions = {
  send({ commit, rootGetters }, assetAssociation) {
    let params = {
      assetAssociationId: assetAssociation.id || assetAssociation,
      state: 'viewed',
      timestamp: Date.now(),
    };

    commit('set', [params]);
    return rootGetters['session/ajax'].post('/asset_association_states', params);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
